import React, { useCallback } from 'react';
import { Control, Controller, useFieldArray } from 'react-hook-form';
import { PlusIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';

import { ICheckList } from '../schema';
import StepForm from './StepForm';

interface IProps {
  control: Control<ICheckList>;
}

const Steps: React.FC<IProps> = ({ control }) => {
  const { fields, append, remove } = useFieldArray({ control, name: 'steps' });

  const handleAppend = useCallback(() => {
    append({
      name: '',
      description: '',
      showPassengerCounter: false,
      form: [],
    });
  }, [append]);

  const handleRemove = useCallback(
    (index: number) => (e: React.MouseEvent) => {
      e.stopPropagation();
      remove(index);
    },
    [remove],
  );

  return (
    <>
      <div>
        <div className="flex justify-between items-center gap-4">
          <h4 className="font-medium">Etapas</h4>
          <Button variant="outline" size="icon" onClick={handleAppend}>
            <PlusIcon className="h-4 w-4" />
          </Button>
        </div>
        <p className="text-sm text-gray-500">
          Adicione etapas ao seu check list. Cada etapa pode ter vários campos
          de formulário.
          <br />
          <Controller
            control={control}
            name="steps"
            render={({ fieldState: { invalid } }) => (
              <span
                className={cn({
                  'text-destructive': invalid,
                })}
              >
                Mínimo de 1 etapa é obrigatório.
              </span>
            )}
          />
        </p>
      </div>
      <div className="flex flex-col gap-6">
        {fields.map(({ id }, index) => (
          <React.Fragment key={id}>
            <StepForm
              key={id}
              control={control}
              name={`steps.${index}`}
              onRemove={handleRemove(index)}
            />
            <Separator />
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default Steps;
